<div  [ngClass]="theme.getThemeClass()"  class="container-fluid bg-light main-dashboard" style="background-color: rgb(255, 255, 255); margin-top: 5px;">

    <section [ngClass]="theme.getThemeClass()" class="dashboard-container row bg-light">
    <app-error-modal></app-error-modal>

    <!-- Section of different dashboard depend on user type -->
    <!-- <truck-list></truck-list> -->
  @if (userType === 'operator' && roles.includes('_driver')) {
  <app-dispatch-network [showPageLoader]="false"></app-dispatch-network>
  }
  @if (userType === 'operator' && roles.includes('_dispatch')) {
 <app-dispatch-network [showPageLoader]="false"></app-dispatch-network>
  }

  <!-- <operator-admin-dashboard></operator-admin-dashboard> -->
    </section>
</div>


